import Text from 'components/commons/Text';
import InputField from 'components/input/InputField';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import IconButton from 'controls/IconButton';
import { validationHelper } from 'controls/validationHelper';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Row, useModelStateContext } from 'saladsoft-primitive';
import { EmailSignUpDto, UserInfoDto, UserProfileDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import styled from 'styled-components';

const MemberForm = ({ member, onSave }: { member?: UserInfoDto; onSave?: () => void }) => {
  const { setState, setMultipleState, stateModel, unmountModel } =
    useModelStateContext<EmailSignUpDto>();
  const { uiStore } = useStoreWrapper();

  const [newPassword, setNewPassword] = useState('');
  const [newPasswordValid, setNewPasswordValid] = useState(false);

  const handleChangePassword = () => {
    uiStore?.confirm.show({
      title: '비밀번호 변경 확인',
      message: '비밀번호를 변경하시겠습니까?',
      onConfirmed: () => {
        if (newPassword) {
          ServiceHelper.adminMemberService
            ?.changePassword(member?.id as number, { newPassword })
            .then((res) => {
              if (res.status === 200) {
                toast.success('비밀번호 변경이 완료되었습니다.');
              }
            });
        }
      },
    });
  };

  const handleClickCreate = () => {
    if (member?.id) {
      ServiceHelper?.adminMemberService
        ?.saveMemberProfile(member?.id, stateModel?.profile as UserProfileDto)
        .then(async (res) => {
          if (res.status === 200) {
            closeModal('사용자 수정이 완료되었습니다.');
            onSave?.();
          } else {
            toast.error('사용자 수정에 실패하였습니다.');
          }
        });
    } else {
      if (stateModel) {
        const newState = { ...stateModel, isActive: true };
        ServiceHelper.adminMemberService?.registerAdminMember(newState).then((res) => {
          if (res.status === 200) {
            closeModal('사용자 추가가 완료되었습니다.');
            onSave?.();
          } else {
            toast.error('사용자 추가에 실패하였습니다.');
          }
        });
      }
    }
  };

  const onClickDelete = (isActive: boolean) => {
    if (member?.id) {
      uiStore?.confirm.show({
        title: isActive ? '사용자정보 활성 확인' : '사용자정보 비활성 확인',
        message: isActive
          ? '사용자 계정을 활성화 하시겠습니까?'
          : '활동 로그 확인을 위해 사용자 계정은 삭제가 불가능합니다.',
        onConfirmed: () => {
          if (!isActive) {
            ServiceHelper?.adminMemberService
              ?.withdrawAdminMember(member?.id as number)
              .then((res) => {
                closeModal('사용자 비활성화가 완료되었습니다.');
                onSave?.();
              });
          } else {
            ServiceHelper?.adminMemberService
              ?.unwithdrawAdminMember(member?.id as number)
              .then((res) => {
                closeModal('사용자 활성화가 완료되었습니다.');
                onSave?.();
              });
          }
        },
      });
    }
  };

  const closeModal = (title: string) => {
    toast.success(title);
    uiStore?.modal.confirm();
  };

  useEffect(() => {
    if (member) {
      setMultipleState(member);
    } else {
      const profile = {
        countryCode: '+82',
        birthday: '2000-01-01',
        address: '버틀러리',
        phoneNumber: '010-1234-5678',
      };
      setMultipleState({ profile });
    }
  }, [member]);

  useEffect(() => {
    return () => {
      unmountModel();
    };
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <InnerSection>
        <InnerGroup>
          <div>
            <Text type="H3">사용자정보</Text>
            <Text type="H4">사용자정보를 입력 해주세요.</Text>
          </div>
          <Row gap={10} flexDirection="column" width="100%" alignItems="space-between">
            <div style={{ width: '100%' }}>
              <InputField
                disabled={!!member?.id}
                label="이메일(아이디)"
                defaultValue={member?.username}
                onChange={(value) => setState('username', value)}
              />
              {!member?.id ? (
                <InputField
                  style={{ marginTop: 10 }}
                  label="비밀번호"
                  type="password"
                  onChange={(value) => setState('password', value)}
                />
              ) : (
                <Row gap={10} alignItems="flex-end">
                  <InputField
                    style={{ marginTop: 10 }}
                    label="비밀번호(8자 이상 한개이상의 대문자, 숫자)"
                    type="password"
                    onChange={(value) => {
                      const isValid = validationHelper.password(value);
                      setNewPasswordValid(isValid);
                      setNewPassword(value);
                    }}
                  />
                  <Button
                    isValid={newPasswordValid}
                    type="outlined"
                    style={{ margin: '0px 0', width: 180 }}
                    onClick={() => {
                      handleChangePassword();
                    }}
                  >
                    비밀번호 변경
                  </Button>
                </Row>
              )}
            </div>
            <Row gap={10}>
              <div style={{ width: '100%' }}>
                <InputField
                  label="성"
                  defaultValue={member?.profile?.lastName}
                  onChange={(value) =>
                    setState('profile', { ...stateModel?.profile, lastName: value })
                  }
                />
              </div>
              <div style={{ width: '100%' }}>
                <InputField
                  label="이름"
                  defaultValue={member?.profile?.firstName}
                  onChange={(value) =>
                    setState('profile', { ...stateModel?.profile, firstName: value })
                  }
                />
              </div>
            </Row>
          </Row>
        </InnerGroup>
      </InnerSection>

      {/* <InnerSection>
        <InnerGroup>
          <div>
            <Text type="H3">관리자 지정</Text>
            <WarningText style={{ color: '#000' }}>
              해당 사용자가 관리자인경우 선택 해주세요.
            </WarningText>
          </div>
          <div>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox checked={isPlan} onChange={(e) => setState('' e.target.checked)} />
                }
                label="관리자로 지정정"
              />
            </FormGroup>
          </div>
        </InnerGroup>
      </InnerSection> */}
      <Row justifyContent="space-between" gap={10}>
        <Row gap={10}>
          <Button
            type="outlined"
            style={{ marginTop: 20 }}
            onClick={async () => {
              uiStore?.modal.close();
            }}
          >
            취소
          </Button>
          <Button
            style={{ marginTop: 20 }}
            onClick={async () => {
              if (stateModel) {
                handleClickCreate();
              }
            }}
          >
            {member?.id ? '사용자 수정' : '사용자 추가'}
          </Button>
        </Row>
        <>
          {member?.id && (
            <>
              {member?.isWithdrawn ? (
                <Button
                  type="outlined"
                  style={{ marginTop: 20 }}
                  onClick={async () => {
                    onClickDelete(true);
                  }}
                >
                  활성화
                </Button>
              ) : (
                <IconButton
                  type="delete"
                  style={{ marginTop: 20 }}
                  onClick={async () => {
                    onClickDelete(false);
                  }}
                />
              )}
            </>
          )}
        </>
      </Row>
    </div>
  );
};

const WarningText = styled.div`
  color: #ff0000;
  font-size: 12px;
  margin-top: 5px;
`;

export default MemberForm;
